import type { SVGProps } from "react";
const SenecPictogramOrder1 = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M6 24C6 14.0589 14.0589 6 24 6C33.9411 6 42 14.0589 42 24C42 33.9411 33.9411 42 24 42C19.7208 42 15.7927 40.508 12.7038 38.0149C12.274 37.6681 11.6444 37.7353 11.2975 38.1651C10.9507 38.5948 11.0179 39.2244 11.4477 39.5713C14.8794 42.341 19.2473 44 24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 28.2623 5.33444 32.2159 7.6083 35.462C7.92516 35.9143 8.54873 36.0242 9.00108 35.7073C9.45342 35.3904 9.56325 34.7669 9.24639 34.3145C7.20043 31.3938 6 27.8386 6 24Z"
            fill="currentColor"
        />
        <path d="M24.0275 30H26.089V16.491L20.6455 18.79V20.937L24.0275 19.4835V30Z" fill="currentColor" />
    </svg>
);
export default SenecPictogramOrder1;
